export default "__VITE_ASSET__BcVgaraj__"